import {Component, Inject, OnInit} from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {ACTION_DATA_SERVICE, ActionDataService} from '../../../../services/action/data.service';
import {debounce} from '../../../../helper/debounce';
import {IActionTypes} from '../../../../models/action.model';
import {LEADS_DATA_SERVICE, LeadsDataService} from '../../../../services/leads/leads-data.service';
import { IContact, LeadType } from '../../../../models/leads/leads.model';
import {ActionIconHelper} from '../../../../helper/action-icon.helper';
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { ActionHelper } from "../../../../helper/action.helper";

@Component({
  selector: 'fi-lead-type-popup',
  templateUrl: './lead-type-popup.component.html',
  styleUrls: ['./lead-type-popup.component.scss'],
  standalone: false,
})
export class LeadTypePopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  leadTypes: LeadType[] = [];
  suggestedTypes: LeadType[] = [];
  selectActive = false;
  isMany: boolean;
  leads: number[];
  private cancel = false;
  step: number = 0;
  searchedText = '';
  originalSearchedText = '';
  note = '';
  doSearch = debounce(() => this.filterData());
  showSuggestions = false;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_TYPE', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_TYPE', true);
  submitting: boolean;
  inValidNote = false;
  contactToDisplay: IContact;

  constructor(
    public dialogRef: MatDialogRef<LeadTypePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string, leads: number[], isMany: boolean },
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    private dialog: MatDialog,
  @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.isMany = dialogData?.isMany;
    this.leads = dialogData?.leads;

    leadsDataService.getLeadTypes().subscribe(({success, data}) => {
      if (success) {
        this.leadTypes = data.filter(item => !item.Inactive);
      }
    });

    if (!this.isMany) {
      this.leadsDataService.getLeadById(this.leadId).subscribe(({ success, data }) => {
        if (success) {
          this.contactToDisplay = data.Contact;
        }
      });
    }

    leadsMultipleStepByStepService.listenToCancel().subscribe(data => {
      this.cancel = true;
    })
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  private filterData(): void {
    const value = this.searchedText;

    if (!value) {
      this.showSuggestions = false;
      setTimeout(_ => {
        this.suggestedTypes = this.leadTypes;
      }, 300);
      return;
    }

    const searchedValue = value.split(' ').filter(item => item !== '');
    this.suggestedTypes = this.getFilters(searchedValue, [...this.suggestedTypes]);
  }

  private getFilters(searchedValue: string[], allItems: LeadType[]): LeadType[] {
    const result: LeadType[] = [];
    searchedValue.forEach(item => {
      const arr = allItems.filter((elem, index) => {
        const expression = new RegExp(`^${item}| ${item}`, 'gmi');
        const match = expression.test(elem.Name);
        if (match) {
          allItems.splice(index, 1);
        }
        return match;
      });

      result.push(...arr);
    });

    return result;
  }

  toggleSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = !this.selectActive;

    if (this.selectActive) {
      this.suggestedTypes = this.leadTypes;
    }
  }

  showSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = true;
    this.suggestedTypes = this.leadTypes;
  }

  hideSelect(): void {
    this.selectActive = false;
  }

  selectResultItem($event: string): void {
    this.selectedTypeId = +$event;
  }

  get formIsValid(): boolean {
    if (this.isMany) {
      return this.leads.length > 0 && !!this.selectedTypeId && !this.submitting && !this.inValidNote;
    }
    return !!this.leadId && !!this.selectedTypeId && this.originalSearchedText === this.searchedText && !this.submitting && !this.inValidNote;
  }

  submitStepByStep(): void {
    if (this.cancel) {
      return;
    }
    this.clearClassAndCloseDialog(this.dialogRef, 'remove');
    this.actionDataService.changeType(this.leads[this.step], this.note, this.selectedTypeId)
      .subscribe(({ success, data }) => {
        if (this.leads.length - 1 === this.leads.lastIndexOf(this.leads[this.step])) {
          this.submitting = false;
        }

        this.step++;
        this.leadsMultipleStepByStepService.switchToNextStep();

        if (this.leads[this.step]) {
          this.submitStepByStep();
        }
      });
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {

      if (this.isMany) {
        let action: any = {
          Name: 'MULTIPLE_LEADS_STEP_BY_STEP',
          Text: 'Bald geschafft...',
          leadsLength: this.leads.length,
          actionName: 'LEAD_TYPE'
        }
        ActionHelper.doAction({} as any, action, this.dialog, this.leads, true)?.afterClosed().subscribe();
        this.submitStepByStep();
      } else {
        this.submitting = true;
        this.actionDataService.changeType(this.leadId, this.note, this.selectedTypeId)
          .subscribe(({ success, data }) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove');
          }

          this.submitting = false;
        });
      }

    }
  }
}
